<template>
  <v-container class="fill-height d-flex align-center justify-center">
    <v-card class="pa-5 text-center" elevation="2">
      <v-icon x-large color="error">mdi-block-helper</v-icon>
      <h2 class="my-4">{{ t('No_autorizado') }}</h2>
      <p>{{ t('No_tienes_permiso_para_acceder_a_esta_página') }}</p>
      <v-btn color="primary" @click="goHome">{{ t('Volver_a_inicio') }}</v-btn>
    </v-card>
  </v-container>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n();
const router = useRouter();

function goHome() {
  router.push('/');
}
</script>